import * as React from "react";
import * as ReactDOM from "react-dom";
import { Component } from "./app"


ReactDOM.render(
    <Component />,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./client/client.tsx